import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

type Tone = 'success' | 'warning' | 'error' | 'info' | 'neutral';

const TONES: Record<Tone, string> = {
  success:
    'bg-emerald-50 text-emerald-700 border-emerald-200 ' +
    'dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800',
  warning:
    'bg-amber-50 text-amber-700 border-amber-200 ' +
    'dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800',
  error:
    'bg-rose-50 text-rose-700 border-rose-200 ' +
    'dark:bg-rose-950/60 dark:text-rose-300 dark:border-rose-800',
  info:
    'bg-sky-50 text-sky-700 border-sky-200 ' +
    'dark:bg-sky-950/60 dark:text-sky-300 dark:border-sky-800',
  neutral:
    'bg-zinc-100 text-zinc-700 border-zinc-200 ' +
    'dark:bg-zinc-800 dark:text-zinc-200 dark:border-zinc-700',
};

const DOTS: Record<Tone, string> = {
  success: 'bg-emerald-600 dark:bg-emerald-400',
  warning: 'bg-amber-600 dark:bg-amber-400',
  error: 'bg-rose-600 dark:bg-rose-400',
  info: 'bg-sky-600 dark:bg-sky-400',
  neutral: 'bg-zinc-500 dark:bg-zinc-400',
};

export function Badge({
  tone = 'neutral',
  children,
  dot = true,
}: {
  tone?: Tone;
  children: ReactNode;
  dot?: boolean;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium border whitespace-nowrap',
        TONES[tone],
      )}
    >
      {dot && <span className={cn('w-1.5 h-1.5 rounded-full', DOTS[tone])} />}
      {children}
    </span>
  );
}
